import React from "react";

import { Send, Square } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@needl-ai/common/components/ui/tooltip";

interface SendButtonProps {
  onSend: () => void;
  onStop: () => void;
  isStreaming: boolean;
  disabled?: boolean;
  disabledReason?: string;
}

const SendButton: React.FC<SendButtonProps> = ({
  onSend,
  onStop,
  isStreaming,
  disabled = false,
  disabledReason,
}) => {
  if (isStreaming) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={onStop}
            className={
              "p-3 rounded-full transition-all duration-200 flex items-center justify-center shadow-md hover:shadow-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
            }
            data-testid="stop-button"
          >
            <Square size={16} fill="currentColor" />
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Stop generating</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={onSend}
          disabled={disabled}
          className={`p-3 rounded-full transition-all duration-200 flex items-center justify-center shadow-md hover:shadow-lg ${
            disabled
              ? "opacity-50 cursor-not-allowed bg-gray-300 text-gray-500"
              : "bg-primary text-white hover:bg-primary/80 hover:scale-105"
          }`}
          data-testid="send-button"
        >
          <Send size={16} />
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{disabled ? disabledReason || "Enter a message" : "Send message"}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default SendButton;
